import WeatherContent from "./weather-content";

export default WeatherContent;
